import React, { useState, useEffect } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../constants/colors';
import ProbSevRiskElement from '../../../LegalCompliance/Evaluation/CardElements/ProbSevRisk/ProbSevRiskElement';
import Translator from '../../../../../components/helpers/Translator';

export default function GGCLPlantRowIconBlock(props) {
  const { plantIndex, obligationID } = props;
  const { moduleBridgeHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions
  );
  const plantPermissions = useSelector(
    (s) =>
      s.currentPage?.plantListTab?.[obligationID][plantIndex]?.plantPermissions
  );
  const plant = useSelector(
    (s) => s.currentPage?.plantListTab?.[obligationID][plantIndex]
  );

  return (
    <>
      {plantPermissions?.gcl?.module?.plant?.gclResponsibles && (
        <AppRemixIcon
          icon="user"
          title={
            plant.isResponsible
              ? ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="obligation.you.are.responsible"
                  />
                )
              : ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="obligation.you.are.not.responsible"
                  />
                )
          }
          color={plant.isResponsible ? colors.primaryLight : colors.grey300}
          filled={plant.isResponsible}
        />
      )}
      {permissions?.global?.corporateObligations && (
        <AppRemixIcon
          icon="building-4"
          title={
            plant.isCorporate
              ? ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="corporate.obligation"
                  />
                )
              : ''
          }
          color={plant.isCorporate ? colors.danger : colors.grey300}
          filled={plant.isCorporate}
        />
      )}
      {plantPermissions?.gcl?.module?.plant?.maintenanceCheck && (
        <AppRemixIcon
          icon="hammer"
          title={ReactDOMServer.renderToString(
            <Translator file="module-legalCompliance" name="maintenance" />
          )}
          color={plant.maintenanceCheck ? colors.success : colors.grey300}
          className="pointer"
          filled={plant.maintenanceCheck}
        />
      )}
    </>
  );
}
